import { SET_MENU_ITEM_ACTIVE } from '../action-types/menu';

export const setMenuItemActive = (url) => ({
  type: SET_MENU_ITEM_ACTIVE,
  url,
});
